module.exports = __webpack_public_path__ + "static/media/user-alt.9e8a12da.svg";